module.exports = __webpack_public_path__ + "img/ic_launcher_2.5fa3a370.png";